import {  useState, useEffect } from "react";
import ExamsRStyle from "../styles&pics/ExamsRStyle";
import GetResults from "./GetResults";

const ExamsResult = ({ scores, totalScore }) => {
   
    const [storedUser, setStoredUser] = useState(null);
   
    useEffect(() => {
        
        const logged=localStorage.getItem('loggedInUser');
        setStoredUser(logged);
    }, []);

    let serverDataset = new Set();

    if (scores !== null && !isNaN(totalScore)) {
        scores.forEach(score => {
            serverDataset.add({
                question: score.table,
                erid: score.erid,
                score: score.qsc.toFixed(2)
            });
        });
    }
    
    const serverData = [...serverDataset];

    return (
        <>
            <ExamsRStyle />
            <main className="results-main">
                <div className="results-container">
                    {isNaN(totalScore) && scores === null ? (
                        <div className="loader-wrapper">
                            <div className="loader"></div>
                            <p className="loader-text">Έλεγχος και βαθμολόγηση απαντήσεων</p>
                        </div>
                    ) : (
                        <>
                            <div className="results-header">
                                <h2>Αποτελέσματα Εξετάσεων</h2>
                            </div>

                            {scores.map((score, index) => (
                                <div className="result-card" key={index}>
                                    <div className="question-header">
                                        <p className="question-title">Ερώτηση {index + 1}</p>
                                        <p className="question-text">{score.question}</p>
                                    </div>

                                    <div className="answer-section user-answer">
                                        <p className="answer-label">Η απάντησή σας:</p>
                                        {score.userAnswer && <p className="answer-content">{score.userAnswer}</p>}
                                        {score.userCode && <pre className="code-content">{score.userCode}</pre>}
                                    </div>

                                    <div className="answer-section correct-answer">
                                        <p className="answer-label">Η σωστή απάντηση:</p>
                                        {score.correctAnswer && <p className="answer-content">{score.correctAnswer}</p>}
                                        {score.correctCode && <pre className="code-content">{score.correctCode}</pre>}
                                    </div>

                                    <div className="score-badge-container">
                                        <div className={score.qsc >= 0.5 ? "score-badge success" : "score-badge failure"}>
                                            Βαθμολογία: {score.score.toFixed(2)}
                                        </div>
                                    </div>
                                </div>
                            ))}

                            <div className={totalScore >= 5 ? "final-score success-glow" : "final-score failure-glow"}>
                                {totalScore >= 5 ? (
                                    <>
                                        <h3>Συγχαρητήρια! Επιτύχατε!</h3>
                                        <p className="final-score-value">Τελική Βαθμολογία: {totalScore.toFixed(2)}/10</p>
                                    </>
                                ) : (
                                    <>
                                        <h3>Δυστυχώς Αποτύχατε</h3>
                                        <p className="final-score-value">Τελική Βαθμολογία: {totalScore.toFixed(2)}/10</p>
                                        <p className="retry-message">Προσπαθήστε ξανά!</p>
                                    </>
                                )}
                            </div>
                        </>
                    )}
                    {(storedUser !== null && !isNaN(totalScore) && totalScore !== null) ? 
                        <GetResults loggedUser={storedUser} serverData={serverData} totalScore={totalScore} /> : null}
                </div>
            </main>
        </>
    );
};

ExamsResult.defaultProps = {
    scores: null,
    totalScore: null,
}
export default ExamsResult;
